import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const ContentSearchPage = withSuspense(lazy(() => import('./content-search')));
export default ContentSearchPage;
